import { useMediaQueries } from "@hooks/use-media-queries";
import { Link, Text } from "@flat-ui";

// On localhost, the full path is needed.
const legalPage =
  window.location.hostname === "localhost" ? "/legal/index.html" : "/legal/";

/** Renders terms of use and privacy policy text during a signup flow */
export function SignupAcknowledgement(): JSX.Element {
  const { isSmallHeightScreen } = useMediaQueries();

  return (
    // No `component`: MUI mapped the `caption` variant to a span, which is also
    // Text's default.
    <Text
      variant="bodyS"
      sx={{
        // `bodyS` reads `text.primary`; the acknowledgement is a step lighter, as the `caption`
        // variant it replaced was.
        color: "text.secondary",
        marginTop: "auto",
        marginBottom: isSmallHeightScreen ? "30px" : "50px",
        textAlign: "center",
      }}
    >
      By proceeding, you agree to the{" "}
      <Link
        target="_blank"
        // e.g. "https://entry.holobuilder.eu/legal/#terms-of-service"
        href={`${legalPage}#terms-of-service`}
        underline="none"
      >
        terms of use
      </Link>{" "}
      and acknowledge you’ve read our{" "}
      <Link
        target="_blank"
        // e.g. "https://entry.holobuilder.eu/legal/#privacy-policy"
        href={`${legalPage}#privacy-policy`}
        underline="none"
      >
        privacy policy
      </Link>
    </Text>
  );
}
